import ProductType from '../enums/productType';
import ResultType from '../enums/resultType';

/**
 * The function `getDefaultProductType` returns a default product type based on the input product type.
 * @param productType - The `productType` parameter is a variable that represents the type of product.
 * @returns The function `getDefaultProductType` returns a string value representing the default
 * product type.
 */
const getDefaultProductType = (productType, resultType = '') => {
  switch (true) {
    case productType === ProductType.BuildOnYourLot.toString() && ResultType.Locations.toString() === resultType:
    case productType === ProductType.Communities.toString():
    case productType === ProductType.Manufactured.toString() && ResultType.Locations.toString() === resultType:
      return ProductType.Communities.toString();

    case productType === ProductType.Custom.toString() && ResultType.Homes.toString() === resultType:
    case productType === ProductType.Homes.toString():
    case productType === ProductType.Manufactured.toString() && ResultType.Homes.toString() === resultType:
      return ProductType.Homes.toString();

    case productType === ProductType.Custom.toString() && ResultType.Builders.toString() === resultType:
      return ProductType.Communities.toString();
      // This return is going to be evaluated once we're going to develop the Custom Builder feature, pointing to 
      // Communities in the meantime. 

    default:
      return ProductType.Communities.toString();
  }
};

export default getDefaultProductType;
